export class ContactInfo {
  public static fromJson({ phone, email, website }): ContactInfo {
    return new ContactInfo(phone, email, website);
  }
  constructor(public phone = '', public email = '', public website = '') { }
}
